import React from 'react'
import { AA_SERVICES_IMAGE } from '../../helpers/constants'
import ContactUs from '../ContactUs/Button'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-section='aa-services'>
      <picture data-type='image'>
        <img
          width='650'
          height='652'
          itemProp='image'
          className='lazyload'
          data-src={AA_SERVICES_IMAGE}
          alt='services'
          role='presentation'
          data-type='image'
        />
      </picture>
      <div data-type='text-section'>
        <p data-type='subtitle'>Saatchi Art’s Art Advisory Services Include:</p>
        <div data-type='underline' />
        <ul>
          <li>Project consultation</li>
          <li>Site evaluation</li>
          <li>Budget formulation and cost analysis</li>
          <li>Concept development</li>
          <li>Project management </li>
          <li>Expert art curation and sourcing</li>
          <li>High-quality art production and fabrication in all mediums</li>
          <li>Custom printing and framing</li>
          <li>Delivery and installation</li>
        </ul>
        <ContactUs />
      </div>
    </div>
  )
}

export default Component